// API
import { useApiSWRReference } from '@/hooks/useApiSWR'

import { MultiSelect, Select } from '@mantine/core'

export default function ComponentCategorySelect({
    onChange,
    value,
    multiple = false,
    ...props
}) {
    const { data: categories } = useApiSWRReference('/component-categories')

    const categoryOptions =
        categories?.map((c) => ({
            value: c.slug,
            label: c.name_fr,
        })) ?? []

    if (!multiple) {
        return (
            <Select
                label="Catégorie"
                placeholder="Cadran, boitier, tête de montre, bracelet..."
                value={value ?? []}
                data={categoryOptions}
                onChange={onChange}
                allowDeselect={true}
                searchable={true}
                {...props}
            />
        )
    }

    return (
        <MultiSelect
            label="Catégories"
            placeholder="Cadran, boitier, tête de montre, bracelet..."
            description="Sélectionnez une ou plusieurs catégories."
            value={value ?? []}
            data={categoryOptions}
            onChange={onChange}
            {...props}
        />
    )
}
